import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoorHanger: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDoorHanger"><Path d="M5.5 8.5H8.5C8.5 6.42769 9.49459 4.5 12 4.5C13.7949 4.5 15.25 6.0603 15.25 7.8C15.25 13.8858 5.5 11.1191 5.5 17.1272V22.5H18.5V7.8C18.5 4.32061 15.5899 1.5 12 1.5C7.73077 1.5 5.5 4.5 5.5 8.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconDoorHanger;
